export default "__VITE_ASSET__Un2gqSNm__"